/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-17 10:09:42
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbRole {
    /**
     * 查询角色下拉列表
     */
    export var GetTbRoleDropList = (body: any): Promise<any> => {
        return Get(`/api/TbRole/GetTbRoleDropList`, body);
    };
    /**
    * 新增角色
    */
   export var PostTbRole = (body: any): Promise<any> => {
       return Post(`/api/TbRole/PostTbRole`, body);
   };
   /**
    * 修改角色
    */
   export var PutTbRole = (body: any): Promise<any> => {
       return Put(`/api/TbRole/PutTbRole`, body);
   };
   /**
    * 删除角色
    */
   export var DeleteTbRole = (id: any): Promise<any> => {
       return Delete(`/api/TbRole/DeleteTbRole?id=${id}`, {});
   };
   /**
     * 查询角色列表
     */
    export var GetTbRoleList = (body: any): Promise<any> => {
        return Get(`/api/TbRole/GetTbRoleList`, body);
    };
    /**
     * 查询角色信息
     */
     export var GetTbRoleById = (id: any): Promise<any> => {
        return Get(`/api/TbRole/GetTbRoleById?id=${id}`, {});
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbRole.ts